export default __webpack_public_path__ + "static/media/puzzle5.3e8d5826.svg";